<div
  class="auth"
  style="
    background-image: url(../../../assets/images/originals/bg9.jpg);
    background-repeat: no-repeat;
    background-size: auto;
    background-position: center center;
  "
>
  <div class="row d-flex g-0">
    <div class="d-none d-lg-block login-sidebar col-lg-4 px-5">
      <div class="slider-light">
        <div
          class="position-relative h-100 d-flex justify-content-center align-items-center"
        >
          <div class="slide-img-bg"></div>
          <div class="slider-content text-light">
            <h3>{{ "Form.THANK_YOU_TITLE" | translate }}</h3>
            <p>
              {{ "Form.Login.ARCHITECTURE_INFO_MESSAGE" | translate }}
            </p>
            <div>
              <ul>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT1HEADING" | translate }}</strong>
                  {{ "Form.Login.Point1" | translate }}
                </li>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT2HEADING" | translate }}</strong>
                  {{ "Form.Login.Point2" | translate }}
                </li>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT3HEADING" | translate }}</strong>
                  {{ "Form.Login.Point3" | translate }}
                </li>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT4HEADING" | translate }}</strong>
                  {{ "Form.Login.Point4" | translate }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="d-md-flex d-sm-block justify-content-center align-items-center col-md-12 col-lg-8 forgot-password"
    >
      <div class="mx-auto app-login-box col-md-6 card p-5">
        <h4 class="mb-4 text-center">
          <img src="../../../assets/images/logo-blue.png" width="200" />
        </h4>

        <h3 class="mb-1">{{ "Form.ForgotPassword" | translate }}</h3>
        <h5 class="mb-3">{{ "Form.ForgotPasswordMessage" | translate }}</h5>

        <div>
          <form [formGroup]="registerForm" class="needs-validation">
            <div class="row">
              <div class="col-md-12">
                <fieldset class="form-group d-flex" id="__BVID__133">
                  <div
                    tabindex="-1"
                    role="group"
                    class="d-flex flex-wrap align-items-center"
                  >
                    <label for="exampleEmail" style="width: 80px">{{
                      "Form.EMAIL" | translate
                    }}</label>
                    <input
                      formControlName="emailId"
                      name="emailId"
                      id="email_id"
                      placeholder="{{ 'Form.Placeholder.EMAIL' | translate }} "
                      type="text"
                      style="width: 250px"
                      class="form-control"
                      required
                    />
                    <div
                      *ngIf="submitted && f.emailId.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="f.emailId.errors.required">
                        {{ "Form.Error.EMAIL" | translate }}
                      </div>
                      <div *ngIf="f.emailId.errors.email">
                        {{ "Form.Error.InvalidEmail" | translate }}
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div class="align-items-center">
              <h6 class="mb-4">
                <a [routerLink]="['/login']" class="text-primary">{{
                  "Form.SignInExistingAccount" | translate
                }}</a>
              </h6>

              <div class="modal-footer text-right justify-content-start">
                <button
                  type="submit"
                  class="btn btn-primary btn-lg"
                  (click)="onSubmit()"
                >
                  {{ "Form.Login.RECOVER_PASSWORD" | translate }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
